export default "__VITE_ASSET__76e16631__"